import { Link, useNavigate } from "react-router-dom"

export const Header = ({ actives, subactive }) => {
    const navigate = useNavigate()

    return (
        <>
            <div className="row shadow sticky p-0" >
                <div className="col-12 p-0">
                    <nav className="nav">
                        <div className="wrapper " >
                            <div className="logo ">
                                <a href="javascript:void(0)"
                                    onClick={() => navigate('/')}>
                                    <img src="Static/Assets/Img/logo.png" alt="logo here" className="logo_bg2" />
                                </a>
                                {/* <a href="#">Logo</a> */}
                            </div>
                            <input type="radio" name="slider" id="menu-btn" />
                            <input type="radio" name="slider" id="close-btn" />
                            <h3 className="full_form">Marine Insurance Learning and Sharing Online</h3>
                            <ul className="nav-links pl-0">
                                <label htmlFor="close-btn" className="btn close-btn"><i className="fas fa-times text-white border px-2 py-1 rounded"></i></label>
                                <li>
                                    <a href="javascript:void(0)"
                                        onClick={() => navigate('/')}
                                        className={actives == "Home" ? "actives" : "text-white"}>
                                        Home
                                    </a>
                                </li>

                                {/* <li>
                                    <a href="/Overview" className={actives == "Overview" ? "actives" : "text-white"}
                                    >About</a>
                                </li> */}

                                <li className="cursor_pointer">
                                    <a className={subactive == "About" ? "actives" : "text-white desktop-item "}>About <i className="fa-solid fa-caret-down ps-2"></i></a>
                                    <input type="checkbox" id="showDrop" />
                                    <label htmlFor="showDrop" className="mobile-item text-white">Overview <i className="fa-solid fa-caret-down ps-2"></i></label>
                                    <ul className="drop-menus">
                                        <li className="">
                                            <a
                                                // href="/Overview?ScreenName=Overview&Name=About"
                                                href="javascript:void(0)"
                                                onClick={() => navigate('/Overview?ScreenName=Overview&Name=About')}
                                                className={actives == "Overview" ? "actives border" : "text-white border"}>Overview</a></li>

                                        <li className="pb-2 pb-lg-0">
                                            <a
                                                // href="/OurTeam?ScreenName=OurTeam&Name=About"
                                                href="javascript:void(0)"
                                                onClick={() => navigate('/OurTeam?ScreenName=OurTeam&Name=About')}
                                                className={actives == "OurTeam" ? "actives border" : "text-white borders"}>Our Team</a></li>

                                        {/* <li className="pb-2 pb-lg-0"><a href="/Values?ScreenName=Values&Name=About"
                                            className={actives == "Values" ? "actives border" : "text-white borders"}>Values</a></li>

                                        <li className="pb-2 pb-lg-0"><a href="/Commitment?ScreenName=Commitment&Name=About"
                                            className={actives == "Commitment" ? "actives border" : "text-white borders"}>Commitment</a></li> */}
                                    </ul>
                                </li>

                                <li className="cursor_pointer">
                                    <a className={subactive == "Services" ? "actives" : "text-white desktop-item "}>Services <i className="fa-solid fa-caret-down ps-2"></i></a>
                                    <input type="checkbox" id="showDrop" />
                                    <label htmlFor="showDrop" className="mobile-item text-white">Services <i className="fa-solid fa-caret-down ps-2"></i></label>
                                    <ul className="drop-menus">
                                        <li className="">
                                            <a
                                                // href="/LearningAndDevelopment?ScreenName=LearningAndDevelopment&Name=Services"
                                                href="javascript:void(0)"
                                                onClick={() => navigate('/LearningAndDevelopment?ScreenName=LearningAndDevelopment&Name=Services&Section=Learning And Development')}
                                                className={actives == "LearningAndDevelopment" ? "actives border pb-4 pb-lg-0" : "text-white border  pb-4 pb-lg-0"}>Learning & Development</a></li>

                                        <li className="pb-2 pb-lg-0">
                                            <a
                                                // href="/Consultancy?ScreenName=Consultancy&Name=Services"
                                                href="javascript:void(0)"
                                                onClick={() => navigate('/Consultancy?ScreenName=Consultancy&Name=Services')}
                                                className={actives == "Consultancy" ? "actives borders" : "text-white borders"}>Consultancy</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a
                                        // href="/Webinars?ScreenName=Webinars&Name=Services" 
                                        href="javascript:void(0)"
                                        onClick={() => navigate('/Webinars?ScreenName=Webinars&Name=Services')}
                                        className={actives == "Webinars" ? "actives" : "text-white"}>Webinars</a>
                                </li>

                                <li>
                                    <a
                                        // href="/Contact" 
                                        href="javascript:void(0)"
                                        onClick={() => navigate('/Contact')}
                                        className={actives == "Contact" ? "actives" : "text-white"}
                                    >Contact</a>
                                </li>

                                <li>
                                    <a
                                        onClick={() => navigate('/adminlogin')}
                                        style={{ cursor: 'pointer' }}
                                        className={actives == "Login" ? "actives" : "text-white"}
                                    >Login</a>
                                </li>


                            </ul>
                            <label htmlFor="menu-btn" className="btn menu-btn"><i className="fas fa-bars"></i></label>
                        </div>

                    </nav>

                </div>
            </div>
        </>
    )
}
